import round from 'lodash/round';

import { Tooltip, Typography, Stack, tokens } from '@cast/design-system';

import { Money } from 'components/money';

type Props = {
  cost?: string;
  basePrice?: string;
  testId?: string;
};

export const NodeCostCellBasePrice = ({ cost, basePrice, testId }: Props) => {
  if (!cost) {
    return <span>$--.--</span>;
  }

  return (
    <Typography noWrap variant="inherit">
      <Tooltip
        title={
          <Stack direction="row" gap={5}>
            <Typography variant="P12R">Base price: </Typography>
            <Typography variant="P12B">
              <Money
                amount={round(Number(basePrice), 3)}
                fixed={3}
                precision={3}
                suffix=" /h"
              />
            </Typography>
          </Stack>
        }
        placement="top"
        arrow
      >
        <span>
          <Money amount={+cost} fixed={3} precision={3} testId={testId} />
        </span>
      </Tooltip>
      <Typography
        component="span"
        color={tokens.theme.fg.structural.secondary}
        variant="P12R"
      >
        {' /h'}
      </Typography>
    </Typography>
  );
};
